import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles(() => ({
  sectionTitle: {
    color: '#444',
    padding: 10,
  },
  title: { fontWeight: 'bolder', paddingTop: '20px' },
}))
